<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Planilla Diaria</div>
          <div class="title-sub">Gestión de asistencia por fecha</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content [fullscreen]="false">

    <!-- Selector Semanal -->
    <div class="week-calendar-card">
      <!-- Encabezado de navegación con filtro integrado arriba de la fecha -->
      <div class="week-nav">
        <button class="nav-btn" (click)="prevWeek()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </button>
        <div class="week-center-group">
          <div class="filter-container">
            <span 
              class="filter-toggle-btn" 
              [class.active]="filterOnlyRegistered" 
              (click)="toggleFilter()">
              <ion-icon [name]="filterOnlyRegistered ? 'funnel' : 'funnel-outline'"></ion-icon>
              <span>Solo con planilla</span>
              <span class="badge-count" *ngIf="highlightedDates.length > 0">{{ highlightedDates.length }}</span>
            </span>
          </div>
          <span class="week-label">{{ weekLabel }}</span>
        </div>
        <button class="nav-btn" (click)="nextWeek()">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </button>
      </div>

      <!-- Lista de fechas con planilla (Carrusel horizontal premium) -->
      <div class="registered-dates-carousel" *ngIf="filterOnlyRegistered && highlightedDates.length > 0">
        <div 
          *ngFor="let h of highlightedDates" 
          class="date-pill" 
          [class.selected]="selectedDate === h.date"
          (click)="selectPillDate(h.date)">
          <ion-icon name="calendar-outline"></ion-icon>
          <span>{{ formatPillDate(h.date) }}</span>
        </div>
      </div>
      <div class="no-registered-dates" *ngIf="filterOnlyRegistered && highlightedDates.length === 0">
        No hay planillas registradas para este trabajo.
      </div>

      <!-- Grilla de 7 días -->
      <div class="week-days-grid">
        <div
          *ngFor="let day of weekDays; let i = index"
          class="day-cell"
          [class.today]="isToday(day)"
          [class.selected]="isSelected(day)"
          [class.has-activity]="isHighlighted(day)"
          [class.faded-out]="filterOnlyRegistered && !isHighlighted(day)"
          (click)="(!filterOnlyRegistered || isHighlighted(day)) ? selectDay(day) : null">
          <span class="day-name">{{ DAY_NAMES[i] }}</span>
          <span class="day-num">{{ day.getDate() }}</span>
          <span class="activity-dot" *ngIf="isHighlighted(day)"></span>
        </div>
      </div>
    </div>

    <!-- Daily Summary & Actions -->
    <div class="summary-section">
      <div class="summary-card">
        <div class="summary-col">
          <span class="label">Total del Día</span>
          <span class="amount">{{ totalDayAmount | currency:'USD':'symbol':'1.0-0' }}</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-col">
          <span class="label">Trabajadores</span>
          <span class="count">{{ dailyWorkers.length }}</span>
        </div>
      </div>
    </div>

    <!-- Workers List (Collapsible) -->
    <div class="workers-section" *ngIf="dailyWorkers.length > 0">
      <div class="section-header">
        <h3>Lista de Trabajadores</h3>
      </div>

      <!-- List -->
      <div class="worker-item" *ngFor="let worker of dailyWorkers" (click)="editActivity(worker)">
        <div class="item-main">
          <div class="avatar" [class.night]="worker.turno === 'N'">{{ worker.nombre.charAt(0) }}</div>
          <div class="info">
            <h2>{{ worker.nombre }}</h2>
            <p>{{ worker.rol || 'Colaborador' }} <span *ngIf="worker.alias">• {{ worker.alias }}</span></p>
          </div>
          <div class="total">
            {{ worker.monto | currency:'USD':'symbol':'1.0-0' }}
          </div>
        </div>

        <div class="item-footer">
          <div class="tags">
            <span class="tag shift-d" *ngIf="worker.turno === 'D'">☀️ Diurno</span>
            <span class="tag shift-n" *ngIf="worker.turno === 'N'">🌙 Nocturno</span>
            <span class="tag subcontrato" *ngIf="worker.subcontrato">🏗️ Subcontrato</span>
            <span class="tag extra" *ngIf="worker.extra > 0">+{{ worker.extra }}</span>
            <span class="tag discount" *ngIf="worker.descuento > 0">-{{ worker.descuento }}</span>
          </div>
        </div>

        <!-- Note display if exists -->
        <div class="item-note" *ngIf="worker.comentario">
          <ion-icon name="document-text-outline"></ion-icon>
          <span>{{ worker.comentario }}</span>
        </div>
      </div>

    </div>

  </ion-content>

  <div class="form-footer-actions">
    <ion-button expand="block" class="save-btn" (click)="addWorker()">
      <ion-icon name="person-add-outline" slot="start"></ion-icon>
      Agregar Trabajadores
    </ion-button>
  </div>

</div>
